// src/App.js
import './Utils/sentry';
import React, { useContext } from 'react';
import { AuthProvider } from './Contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routers from './Routes/routers';
import './App.css';
import Loader from './Components/Loader';
import { LoadingProvider, LoadingContext } from './Contexts/LoadingContext';
import AxiosWrapper from './Api/http/AxiosWrapper';
import { DrawerProvider } from './Contexts/DrawerContext';

function App() {
  const { loading, setLoading } = useContext(LoadingContext) || {}; // Provide a default empty object if the context is undefined
  // Create an instance of AxiosWrapper with setLoading
  const axiosWrapper = new AxiosWrapper(
    process.env.REACT_APP_API_URL,
    'username',
    'password',
    setLoading,
  );

  return (
    <LoadingProvider>
      <DrawerProvider>
        <div className="App">
          <AuthProvider>
            <>
              {loading && <Loader />}
              <Routers axiosWrapper={axiosWrapper} />
              <ToastContainer />
            </>
          </AuthProvider>
        </div>
      </DrawerProvider>
    </LoadingProvider>
  );
}

export default App;
